import * as React from "react";

import GenericIconProps from './_icon.type';

function EmailIcon({className = 'fill-gray-900'}: GenericIconProps) {
  return (
    <svg
      className={className || ''}
      width="16"
      height="12"
      viewBox="0 0 16 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M1.71429 0C1.26035 0.00232382 0.825659 0.183682 0.50467 0.50467C0.183682 0.825659 0.00232382 1.26035 0 1.71429L0 9.33333C0.00241234 9.78724 0.183799 10.2219 0.504768 10.5428C0.825738 10.8638 1.26037 11.0452 1.71429 11.0476H14.2857C14.7396 11.0452 15.1743 10.8638 15.4952 10.5428C15.8162 10.2219 15.9976 9.78724 16 9.33333V1.71429C15.9976 1.26037 15.8162 0.825738 15.4952 0.504768C15.1743 0.183799 14.7396 0.00241234 14.2857 0L1.71429 0ZM1.83912 1.14286H14.1667L8.35034 6.33333C8.12857 6.53129 7.88231 6.53163 7.65986 6.33333L1.83912 1.14252V1.14286ZM1.14286 2.05374L5.05952 5.54762L1.14286 9.30952V2.05374ZM14.8571 2.05374V9.30374L10.9524 5.54184L14.8571 2.05374ZM10.0952 6.30952L13.8276 9.90442H2.17279L5.91837 6.31564L6.90034 7.19047C7.20627 7.4598 7.59989 7.60838 8.00748 7.60838C8.41508 7.60838 8.80869 7.4598 9.11463 7.19047L10.0969 6.30952H10.0952Z" />
    </svg>
  )
};

export default EmailIcon;
